import fontAwesome from "./components/font-awesome";
import accordion from "./components/accordion";
import mobileNav from "./components/mobile-nav";
import primaryNav from "./components/primary-nav";
import toaster from "./components/toaster";
import scrollEffects from "./components/scroll-effects";
import search from "./components/search";

document.addEventListener("DOMContentLoaded", function() {
    fontAwesome();
    // accordion();
    mobileNav();
    toaster();
    primaryNav();
    // scrollEffects();
    // search();
});